<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>

<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <p-button (onClick)="onBpttAdd()" label="Add Budget Product Tag" icon="pi pi-plus"
      size="small" [disabled]="isReadOnly()"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
  </div>

  <p-splitter class="grow w-full qb-splitter-after-actions" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
    <ng-template pTemplate>
      <div class="qb-splitter-panel">
        <div class="qb-splitter-grid">
          <prox-ag-grid [gridOptions]="bpttGridOptions" [rowData]="bptts"></prox-ag-grid>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="qb-splitter-panel">
        <div class="qb-child-actions">
          <p-button [disabled]="!selectedBptt || isReadOnly()" (onClick)="onTmapAdd()"
            label="Assign Product Types" icon="pi pi-plus" size="small"></p-button>
        </div>
        <div class="qb-splitter-grid">
          <prox-ag-grid [gridOptions]="tmapGridOptions" [rowData]="tmaps"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>